import React from 'react'
const Navbar = () => {
  return (
    <div className="navbar">
        <a href='/'>Home</a>
        <a href='#About'>About me</a>
        <a href='#Projects'>Projects</a>
        <a href='#Skills'>Skills</a>
        <a href='#Contact'>Contact me</a>
    </div>
  )
}

export default Navbar